import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import SvgIcon from '@adsk/bim360-matrix-react-svg-icon';
import svgs from '@adsk/bim360-matrix-react-assets';
import { useTheme, Themes } from '@adsk/bim360-matrix-react-helpers/es/theme';

import './_EmptyState.scss';

const matrixIcons = {
  CONE: { children: svgs['cone'], height: '120px', width: '120px' },
  EMPTY_BOX: { children: svgs['empty-box'], height: '153px', width: '86px' },
  NOT_FOUND: { children: svgs['not-found'], height: '160px', width: '380px' },
  NO_PERMISSIONS: { children: svgs['no-permissions'], height: '118px', width: '100px' },
  EMPTY_TEMPLATE: { children: svgs['empty-template'], height: '100px', width: '175px' },
  NO_PROJECTS: { children: svgs['no-projects'], height: '120px', width: '140px' }
};

const alloyIcons = {
  ERROR: { children: svgs['alloy-error-crane'], height: '150px', width: '150px' },
  NO_DATA: { children: svgs['alloy-no-data'], height: '150px', width: '150px' },
  NO_RESULTS: { children: svgs['alloy-no-results'], height: '150px', width: '150px' },
  NO_PERMISSION: { children: svgs['alloy-no-permission'], height: '150px', width: '150px' }
};

const getIcon = (icon, theme) => {
  if (theme === Themes.ALLOY) {
    if (icon === matrixIcons.CONE) {
      return alloyIcons.ERROR;
    } else if (icon === matrixIcons.EMPTY_BOX || icon === matrixIcons.EMPTY_TEMPLATE) {
      return alloyIcons.NO_DATA;
    } else if (icon === matrixIcons.NOT_FOUND || icon === matrixIcons.NO_PROJECTS) {
      return alloyIcons.NO_RESULTS;
    } else if (icon === matrixIcons.NO_PERMISSIONS) {
      return alloyIcons.NO_PERMISSION;
    }
  }
  return icon;
};

const EmptyState = props => {
  const { icon, text, footer, style, className } = props;
  const { theme } = useTheme();
  const emptyStateClassNames = classNames('EmptyState', `EmptyState--${theme}`, className);

  return (
    <div style={style} className={emptyStateClassNames}>
      <div>
        <SvgIcon {...getIcon(icon, theme)} />
      </div>
      {text && <div className="EmptyState__text">{text}</div>}
      {footer}
    </div>
  );
};

EmptyState.Icons = matrixIcons;

EmptyState.propTypes = {
  /**
   * An object that represents the svg to use as the icon for the empty state.
   */
  icon: PropTypes.shape(SvgIcon.propTypes).isRequired,
  /**
   * text that will be displayed in below the icon.
   */
  text: PropTypes.string,
  /**
   * A custom node that will be displayed in below the text.
   */
  footer: PropTypes.node,
  /**
   * Additional className.
   */
  className: PropTypes.string,
  /**
   * A custom style for the element of the component.
   */
  style: PropTypes.object
};

export default EmptyState;
